import React from "react";
import { CircleCheck } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { AspectRatio } from "@/components/ui/aspect-ratio";
const categories = [{
  id: "government-enterprise",
  title: "Government & Enterprise",
  description: "Strategic cybersecurity governance, compliance alignment and resilient technology solutions for public sector and enterprise organizations.",
  imageSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683494/img/abu_dhabi_government_sector.png",
  imageSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683494/img/abu_dhabi_government_sector.png-wvc-srcset",
  imageSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683494/img/abu_dhabi_government_sector.png-wvc-sizes",
  imageAlt: "Professional corporate environment in Abu Dhabi",
  link: "/IndustriesExperiencePage"
}, {
  id: "banking-finance",
  title: "FINTECH & REGTECH SOLUTIONS",
  description: "Secure, compliance-driven technology solutions supporting AML/KYC enablement, financial crime controls and trusted digital integrations.",
  imageSrc: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683494/img/uae_banking_security.png",
  imageSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683494/img/uae_banking_security.png-wvc-srcset",
  imageSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683494/img/uae_banking_security.png-wvc-sizes",
  imageAlt: "Modern financial district architecture",
  link: "/IndustriesExperiencePage"
}];
const categoryFeatures = [{
  categoryId: "government-enterprise",
  text: "Cybersecurity & Compliance Alignment"
}, {
  categoryId: "government-enterprise",
  text: "Security Operations Advisory"
}, {
  categoryId: "government-enterprise",
  text: "Secure Infrastructure Modernization"
}, {
  categoryId: "banking-finance",
  text: "AML & KYC Technology Enablement"
}, {
  categoryId: "banking-finance",
  text: "Secure API Integrations"
}, {
  categoryId: "banking-finance",
  text: "Compliance & Regulatory Enablement"
}];
export default function IndustriesOverview() {
  return <section data-section-id="259214" id="industries-overview" className="bg-background text-foreground py-16 md:py-24">
      <div className="page-container">
        <div className="max-w-3xl mx-auto text-center mb-12 md:mb-16">
          <h2 className="font-default text-4xl md:text-5xl font-bold uppercase mb-4 tracking-tight">
            Industries We Serve
          </h2>
          <p className="text-muted-foreground text-lg font-default">
            Expert technical consultancy delivering security and stability across the UAE's core sectors
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 max-w-5xl mx-auto">
          {categories.map((category, i) => {
          const features = categoryFeatures.filter(f => f.categoryId === category.id);
          return <Card key={category.id} data-index={i} className="bg-card border-border overflow-hidden flex flex-col transition-all duration-300 hover:border-primary/50 hover:shadow-xl hover:-translate-y-1 rounded-lg">
                <div className="w-full">
                  <AspectRatio ratio={16 / 9}>
                    <img src={category.imageSrc} data-wvc-srcset={category.imageSrcset} data-wvc-sizes={category.imageSizes} alt={category.imageAlt} className="object-cover w-full h-full grayscale hover:grayscale-0 transition-all duration-500" loading="lazy" />
                  </AspectRatio>
                </div>
                
                <CardContent className="p-6 md:p-8 flex-grow flex flex-col">
                  <h3 className="font-default text-2xl md:text-3xl font-bold uppercase mb-3 text-foreground">
                    {category.title}
                  </h3>
                  <p className="text-muted-foreground mb-6 text-sm md:text-base font-default">
                    {category.description}
                  </p>
                  
                  <ul className="space-y-3 mb-8 flex-grow">
                    {features.map((feature, j) => <li key={j} data-index={j} className="flex items-start gap-3 text-sm md:text-base">
                        <CircleCheck className="w-5 h-5 text-primary shrink-0 mt-0.5" />
                        <span className="text-foreground font-default">{feature.text}</span>
                      </li>)}
                  </ul>
                  
                  <Button variant="outline" className="w-full bg-transparent border-primary text-primary hover:bg-primary hover:text-primary-foreground transition-colors rounded-md font-default font-semibold" asChild>
                    <Link to={category.link}>
                      Explore Solutions
                    </Link>
                  </Button>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}